document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.contact__form');

    if (!form) return;

    const successPanel = document.querySelector('.contact__success');
    const errorMsg     = form.querySelector('.contact__message--error');
    const submitBtn    = form.querySelector('.contact__submit');
    const consentLabel = document.getElementById('contact-consent-label');
    const resetBtn     = document.querySelector('.contact__reset');

    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function setFieldInvalid(input, invalid) {
        input.closest('[data-field]').classList.toggle('contact__field--invalid', invalid);
    }

    function showError(text) {
        errorMsg.textContent = text;
        errorMsg.classList.toggle('contact__message--hidden', !text);
    }

    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            form.reset();
            form.style.display = '';
            successPanel.classList.add('contact__success--hidden');
            form.querySelector('[name="contact_name"]').focus();
        });
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        const nameEl    = form.querySelector('[name="contact_name"]');
        const emailEl   = form.querySelector('[name="contact_email"]');
        const msgEl     = form.querySelector('[name="contact_message"]');
        const phoneEl   = form.querySelector('[name="contact_phone"]');
        const consentEl = form.querySelector('[name="contact_consent"]');

        const name    = nameEl.value.trim();
        const email   = emailEl.value.trim();
        const message = msgEl.value.trim();
        const consent = consentEl.checked;
        const nonce   = form.querySelector('[name="nonce"]').value;

        let ok = true;

        setFieldInvalid(nameEl, !name);
        if (!name) ok = false;

        setFieldInvalid(emailEl, !email || !emailRe.test(email));
        if (!email || !emailRe.test(email)) ok = false;

        setFieldInvalid(msgEl, !message);
        if (!message) ok = false;

        consentLabel.classList.toggle('contact__consent--invalid', !consent);
        if (!consent) ok = false;

        if (!ok) return;

        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');

        showError('');

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: new URLSearchParams({
                action:          'contact_form_submit',
                nonce:           nonce,
                contact_name:    name,
                contact_email:   email,
                contact_phone:   phoneEl ? phoneEl.value.trim() : '',
                contact_message: message,
                contact_consent: '1',
            }),
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    form.style.display = 'none';
                    if (successPanel) successPanel.classList.remove('contact__success--hidden');
                } else {
                    showError(data.data?.message || 'Wystąpił błąd. Spróbuj ponownie.');
                }
            })
            .catch(() => {
                showError('Wystąpił błąd serwera. Spróbuj ponownie później.');
            })
            .finally(() => {
                submitBtn.disabled = false;
                submitBtn.classList.remove('is-loading');
            });
    });
});
